import { createSelector } from 'reselect';
import {
  pathOr, values, find, propEq, compose, map, range 
} from 'ramda';

import { selectUserId } from './userInfo';

const selectRoot = (state) => state.confirmators;

export const selectConfirmatorsList = createSelector(
  selectRoot,
  ({ list }) => values(list)
);

export const selectConfirmatorsStatus = createSelector(
  selectRoot,
  ({ pending }) => pending
);

export const selectUserConfirmLevel = createSelector(
  selectConfirmatorsList,
  selectUserId,
  (confirmers, userId) => {
    const confirmer = find(propEq('userId', userId), confirmers);
    return parseInt(pathOr(0, ['confirmationLevel'], confirmer), 10);
  }
);

export const selectMaxConfirmLevel = createSelector(
  selectRoot,
  (_, confirmId) => confirmId,
  ({ levels }, confirmId) => levels[confirmId] || 0
);

const levelToOption = (level) => ({
  label: level.toString(),
  value: level.toString()
});

export const getConfirmLevelOptions = compose(
  map(levelToOption),
  map((val) => val + 1),
  range(0),
  ({ levels }, reportId) => levels[reportId] || 0
);

export const selectConfirmLevelOptions = createSelector(
  selectRoot,
  (_, reportId) => reportId,
  getConfirmLevelOptions
);